export const setAcYearCompanyList = (lists) => {
    return {
        type: "SET_ACYEAR_COMPANY_LIST",
        lists,
    };
};